import { Navigate } from "react-router-dom";
import { useAuth, hasAnyRole } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center text-muted-foreground">
                Cargando…
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (roles && roles.length && !hasAnyRole(user, ...roles)) {
        return <Navigate to="/" replace />;
    }
    return children;
}
